import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Descendant } from 'slate';
import { appState } from '../../../../AppState';
import { getUser } from '../../../../AuthConfig';
import { mergeStyleSets } from '@fluentui/react';

import SlateEditor from '../../Wysiwyg/SlateEditor';

interface ShowEditorProps {
  isEditorVisible: boolean;
  onChange: (interaction: any) => void;
  teamId: number;
  groupId: number;
  commentBody?: Descendant[];
  disabled: boolean;
  onImagePaste?: (data: File) => void;
  isEndUserPage?: boolean;
}

const classNames = mergeStyleSets({
  editor: {
    '.DraftEditor-editorContainer': {
      overflowY: 'auto',
      maxHeight: '100px !important',
      display: 'flex',
      flexDirection: 'column-reverse'
    }
  }
});

const ShowEditor: React.FC<ShowEditorProps> = ({ disabled, isEditorVisible, onChange, commentBody, onImagePaste, isEndUserPage }: ShowEditorProps) => {
  const onChangeEditorComponent = (data: any) => { onChange(data); };
  const onChangeEditorComponentCallback = useCallback((data: any) => { onChangeEditorComponent(data); }, [onChangeEditorComponent]);

  const commentMemo = useMemo(() => {
    return commentBody ?? [{ children: [{ text: '' }] }];
  }, [commentBody]);

  const [assignees, setAssignees] = useState<PlatformUser[]>([]);
  const currentState = appState();
  const currentUser = getUser();

  useEffect(() => setAssignees(currentState.usersInRole), [currentState.usersInRole]);

  return isEditorVisible ?
    <div className={`${classNames.editor}`}>
      <SlateEditor
        onChange={onChangeEditorComponentCallback}
        slateValue={commentMemo}
        readOnly={disabled}
        usersInMention={isEndUserPage ? [] : assignees.filter(a => a.UserName !== currentUser && a.Id !== -1)}
        isFocus={true}
        noImage={true}
        onImagePaste={onImagePaste}
        minHeight='4rem'
      />
    </div> : <></>
}

export default ShowEditor